import React from 'react';
import { motion } from 'framer-motion';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

//Assets
import image_1 from '../../../../../asset/resource/energy-01.png';
import image_2 from '../../../../../asset/resource/energy-02.png';
import image_3 from '../../../../../asset/resource/energy-03.png';
import image_4 from '../../../../../asset/resource/energy-04.png';

import { useCheckMobile } from '../../../../hooks';

import './UseCases.scss';

const UseCases = () => {
  const isMobile = useCheckMobile({ width: 767 });

  return (
    <section id="use-cases" className="use-cases">
      <div className="use-cases__wrapper">
        <h2 className="use-cases__heading">
          <span>Data-Driven Energy Excellence</span>
          Use cases
        </h2>
        <div className="use-cases__slider-wrapper">
          <Carousel
            showArrows
            infiniteLoop
            showThumbs={false}
            showStatus={false}
            swipeScrollTolerance={20}
            preventMovementUntilSwipeScrollTolerance={40}
          >
            <div className="use-cases__slide-wrapper">
              <div className="use-cases__slide">
                <article>
                  <h3>Industrial Energy Use Optimization</h3>
                  <strong>
                    Minimize the energy use for any climate-controlled industrial process using IoT, digital twins, and
                    AI-driven optimization.
                  </strong>
                  <p>
                    Combine past operational data with real-time information from your production site using suitable
                    IoT devices. Simulate your equipment and weather conditions with a digital twin. Use AI optimization
                    to gain insights for energy optimization across the entire system. Automate implementation with an
                    AI-governed controller for dynamic optimization adjustments. <br />
                    <br />
                    Enact energy-optimized equipment settings — without operational interference.
                  </p>
                </article>
                <figure className="use-cases__image">
                  <img width="100%" src={image_1} className="support-image" />
                </figure>
              </div>
            </div>
            <div className="use-cases__slide-wrapper">
              <div className="use-cases__slide">
                <article>
                  <h3>Dynamic Monitoring and Benchmarking</h3>
                  <strong>
                    Move beyond static, aggregated energy consumption monitoring to acquire actionable insights.
                  </strong>
                  <p>
                    Start by ingesting dynamic performance data from your production facility using IoT infrastructure
                    attached to operational and infrastructural components. Centralize multiple time-dependent sources
                    in one cloud platform to access the cloud architecture, database schemas, and authentication
                    procedures. Unify and prepare your data streams for normalization with select databases for
                    relational and time-series data.
                    <br />
                    <br /> Understand where your energy use is and how you can get it where it needs to be
                  </p>
                </article>
                <figure className="use-cases__image">
                  <img width="100%" src={image_2} className="onboarding-image" />
                </figure>
              </div>
            </div>
            <div className="use-cases__slide-wrapper">
              <div className="use-cases__slide">
                <article>
                  <h3>Grid Stabilization for Green Initiatives</h3>
                  <strong>
                    Optimize energy production in real time to incorporate renewable energy sources and prepare the grid
                    for electrified infrastructure.
                  </strong>
                  <p>
                    Draw on real-time data to enable supply and demand dynamic monitoring and control. Track equipment
                    across multiple circuits for effective energy demand management. Gain comprehensive energy
                    production and consumption views. Ensure reliable electricity production, transmission, and
                    distribution.
                    <br />
                    <br /> Maintain grid stability through all transitions — for safe and rapid sustainable source
                    integration.
                  </p>
                </article>
                <figure className="use-cases__image">
                  <img width="100%" src={image_3} className="planing-image" />
                </figure>
              </div>
            </div>
            <div className="use-cases__slide-wrapper">
              <div className="use-cases__slide">
                <article>
                  <h3>Energy Value Chain Optimization</h3>
                  <strong>
                    Minimize the cost of energy generation and price fluctuations while transitioning to green energy
                    sourcing.
                  </strong>
                  <p>
                    Leverage historical data to understand energy generation and consumption, energy storage, and grid
                    operational aspects. Deploy optimization algorithms to determine an optimal energy-sourcing
                    strategy. Test alternative sourcing with a multi-source energy plan based on simulation and
                    optimization models . Intuitive visualization offers organizational insight into key KPIs. <br />
                    <br />
                    Gain a complete understanding of your energy value chain's current state — and what it could be.
                  </p>
                </article>
                <figure className="use-cases__image">
                  <img width="100%" src={image_4} className="education-image" />
                </figure>
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
